import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PaymentSetupForm from '../components/PaymentSetupForm';

const PaymentSetupPage: React.FC = () => {
  const navigate = useNavigate();
  const { refreshSubscriptionStatus } = useAuth();

  const handleSuccess = async () => {
    await refreshSubscriptionStatus();
    navigate('/dashboard');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Card sx={{ maxWidth: 520, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <PaymentSetupForm onSuccess={handleSuccess} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentSetupPage;
